export interface Address {
    almacenCodigo: string;
    almacenNombre: string;
    agencia: string;
    codigo: number;
    cp: string;
    defecto: boolean;
    direccion: string;
    id: number;
    municipio: string;
    nombre: string;
    nombre64: string;
    pais: string;
    provincia: string;
    agente2: string;
}

export class AddressHelper {
    static create(): Address {
        return {
            almacenCodigo: null,
            almacenNombre: null,
            agencia: null,
            codigo: null,
            cp: null,
            defecto: null,
            direccion: null,
            id: null,
            municipio: null,
            nombre: null,
            nombre64: null,
            pais: null,
            provincia: null,
            agente2: null
        };
    }

    static transformFromAPI(apiData: Object): Address {
        const address = AddressHelper.create();
        address.almacenCodigo = apiData['AL_CODIGO'] ? apiData['AL_CODIGO'] : '';
        address.almacenNombre = apiData['AL_NOMBRE'] ? apiData['AL_NOMBRE'] : '';
        address.agencia = apiData['DI_AGENCIA'] ? apiData['DI_AGENCIA'] : '';
        // address.codigo = apiData['DI_CODIGO'] ? apiData['DI_CODIGO'] : '';
        let diCodigo = apiData['DI_CODIGO'] != null ? Number(apiData['DI_CODIGO']) : undefined;
        diCodigo = isNaN(diCodigo) ? undefined : diCodigo;
        address.codigo = diCodigo;
        address.cp = apiData['DI_CP'] ? apiData['DI_CP'] : '';
        address.defecto = apiData['DI_DEFECTO'] ? apiData['DI_DEFECTO'] : false;
        address.direccion = apiData['DI_DIRECCION'] ? apiData['DI_DIRECCION'] : '';
        let diId = apiData['DI_ID'] != null ? Number(apiData['DI_ID']) : undefined;
        diId = isNaN(diId) ? undefined : diId;
        address.id = diId;
        address.municipio = apiData['DI_MUNICIPIO'] ? apiData['DI_MUNICIPIO'] : '';
        address.nombre = apiData['DI_NOMBRE'] ? apiData['DI_NOMBRE'] : '';
        address.pais = apiData['DI_PAIS'] ? apiData['DI_PAIS'] : '';
        address.provincia = apiData['DI_PROVINCIA'] ? apiData['DI_PROVINCIA'] : '';
        address.nombre64 = apiData['DI_NOMBREB64'] ? apiData['DI_NOMBREB64'] : '';
        address.agente2 = apiData['DI_AGENTE2'];
        return address;
    }
}
